import { StringHelper } from "@octopusdeploy/design-system-octopus-components";
import { links } from "@octopusdeploy/portal-routes";
import type * as React from "react";
import { useProjectContext } from "~/areas/projects/context/index";
import { LegacyPaperLayout, type LegacyPaperLayoutProps } from "~/components/PaperLayout/LegacyPaperLayout";
import SidebarLayout from "~/components/SidebarLayout/SidebarLayout";
import RunbooksNavigationTabs from "../RunbooksNavigationTabs";
export type RunbooksPaperLayoutProps = LegacyPaperLayoutProps & {
    sidebar?: React.ReactNode;
};
const RunbooksPaperLayout: React.FC<RunbooksPaperLayoutProps> = ({ children, sidebar, title = StringHelper.ellipsis, fullWidth = true, ...rest }) => {
    const projectContext = useProjectContext();
    const project = projectContext.state.model;
    return (<LegacyPaperLayout breadcrumbsItems={rest.breadcrumbsItems ?? [{ label: "Runbooks", pageUrl: links.runbooksPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }) }]} title={title} fullWidth={fullWidth} {...rest}>
            <RunbooksNavigationTabs />
            <SidebarLayout sideBar={sidebar}>{children}</SidebarLayout>
        </LegacyPaperLayout>);
};
RunbooksPaperLayout.displayName = "RunbooksPaperLayout"
export default RunbooksPaperLayout;
export { RunbooksPaperLayout };
